// S1 — Environment-Detection (2026-04-23, Doktrin „LIVE = einzige operative Wahrheit")
//
// Kanonische Erkennung der Runtime-Umgebung anhand des Browser-Hostnamens.
// NICHT über process.env — der build-time-injizierte Wert ist historisch unzuverlässig
// gewesen (stale REACT_APP_BACKEND_URL, siehe `/app/memory/MASTER_SANIERUNGS_DOKTRIN.md`).
//
// Feste Definition:
//   - LIVE  = einzige operative Wahrheit  (Hostname: app.solarium-suntime.de)
//   - PREVIEW = Test/Entwicklung          (Hostname enthält .preview.emergentagent.com)
//   - DEV   = lokale Entwicklung          (localhost / 127.0.0.1 / 0.0.0.0)
//   - UNKNOWN = alles andere (defensiv: wie PREVIEW behandelt)

export const ENV_LIVE = "live";
export const ENV_PREVIEW = "preview";
export const ENV_DEV = "dev";
export const ENV_UNKNOWN = "unknown";

const LIVE_HOST = "app.solarium-suntime.de";

export function getEnvironment() {
  if (typeof window === "undefined" || !window.location) return ENV_UNKNOWN;
  const host = (window.location.hostname || "").toLowerCase();
  if (host === LIVE_HOST) return ENV_LIVE;
  if (host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0") return ENV_DEV;
  if (host.includes(".preview.emergentagent.com") || host.includes(".emergent.host")) return ENV_PREVIEW;
  return ENV_UNKNOWN;
}

export function isLive() {
  return getEnvironment() === ENV_LIVE;
}

export function getEnvironmentLabel() {
  switch (getEnvironment()) {
    case ENV_LIVE: return "LIVE";
    case ENV_PREVIEW: return "PREVIEW";
    case ENV_DEV: return "DEV";
    default: return "UNKNOWN";
  }
}
